import type { ApiAxiosError, ApiErrorResponse } from '@/types/apiAxios'

export function isApiAxiosError(error: unknown): error is ApiAxiosError {
  if (!error || typeof error !== 'object') {
    return false
  }

  const candidate = error as Partial<ApiAxiosError>
  return (
    candidate.isAxiosError === true &&
    typeof candidate.response?.status === 'number'
  )
}

export function isApiErrorResponse(error: unknown): error is ApiErrorResponse {
  if (!error || typeof error !== 'object') {
    return false
  }

  const candidate = error as Partial<ApiErrorResponse>
  return (
    typeof candidate.error === 'string' &&
    typeof candidate.message === 'string' &&
    typeof candidate.status === 'number'
  )
}
